import { ValidationResult, ValidationError, RequiredFieldCheck } from '@/views/helpers/validation-result';
import ValidationMessages from '@/views/helpers/validation-messages';
import Regex from '@/shared/constants/regex';

export default {
  validate (employee) {
    let validationResult = new ValidationResult();

    validationResult.push(this.validateDateOfDeath(employee.dateOfDeath, employee.dateOfBirth));
    validationResult.push(this.validateInitials(employee.initials));

    return validationResult;
  },

  requiredFields (employee) {
    let validationResult = new ValidationResult();

    validationResult.push(RequiredFieldCheck('initials', employee.initials));
    validationResult.push(RequiredFieldCheck('lastName', employee.lastName));
    validationResult.push(RequiredFieldCheck('dateOfBirth', employee.dateOfBirth));
    validationResult.push(RequiredFieldCheck('gender', employee.gender));

    return validationResult;
  },

  validateDateOfDeath (dateOfDeath, dateOfBirth) {
    if (dateOfBirth == null) return null;

    if (dateOfDeath != null) {
      if (new Date(dateOfBirth) > new Date(dateOfDeath)) {
        return new ValidationError({
          message: ValidationMessages.Employee.BIRTH_GREATER_THAN_DEATH,
          attribute: 'dateOfDeath'
        });
      }
    }
  },

  validateInitials (initials) {
    if (initials == null) return null;

    if (!Regex.Initials.test(initials)) {
      return new ValidationError({
        message: ValidationMessages.Employee.INITIALS_INVALID_FORMAT,
        attribute: 'initials'
      });
    }
  }
};
